import $dataStr from 'fxdom/es/dataStr.js';
import { html, strMap, range, go, ippL } from 'fxjs/es';
import { UtilImageS } from '../../../../../Util/Image/S/Function/module/UtilImageS.js';
import { UtilS } from '../../../../../Util/S/Function/module/UtilS.js';

export const makePbProductImageHtml = ({ image, idx }) => html`
  <div
    class="pb-thumbnail-editor__photo${idx == 0 ? ` pb-thumbnail-editor__photo--show` : ''}"
    data-id="${image?.id || 0}"
    data-file-id="${image?.file_id}"
    data-idx="${idx}"
  >
    <img
      src="${(image?.url.includes('data:image')
        ? image?.url
        : UtilImageS.getResizedUrl({ url: image?.url, width: 740, format: 'jpeg' })) || ''}"
      alt=""
    />
    <div class="pb-thumbnail-editor__photo-delete">
      <img
        src="//s3.marpple.co/files/u_2308668/2023/6/original/e5d42fddc38f7417d0b7d3b59234678d714c7a271.png"
        alt=""
      />
    </div>
    <div class="pb-thumbnail-editor__photo-set-first">
      <label class="pb-thumbnail-editor__radio-label">
        <input type="radio" name="pb_thumbnail_first" ${idx == 0 ? 'checked' : ''} />
        대표 이미지로 지정
      </label>
    </div>
  </div>
`;

export const makePbThumbnailItem = ({ image, idx }) => {
  return html`
    <li
      class="pb-thumbnail-editor__item pb-thumbnail-editor__item--on${idx == 0
        ? ' pb-thumbnail-editor__item--selected'
        : ''}"
      data-idx="${idx}"
      data-is_file="${!!image.file_id}"
      data-file-id="${image.file_id}"
      data-fx-json="${$dataStr(image)}"
    >
      <img
        src="${image.file_id
          ? UtilS.escape(image.url)
          : UtilImageS.getResizedUrl({ url: image.url, width: 75 }) || ''}"
        class="pb-thumbnail-editor__item-img"
        alt=""
      />
      <span class="pb-thumbnail-editor__item-thumb-del">
        <img
          src="//s3.marpple.co/files/u_218933/2022/9/original/419cff064bd568d0de7a354d3460fefb793ac85e1.png"
          alt="X"
        />
      </span>
    </li>
  `;
};

export const makePbThumbnailEditorHtml = (images = []) => {
  return html`
    <div class="pb-thumbnail-editor">
      <ul class="pb-thumbnail-editor__list">
        ${strMap((idx) => {
          if (!images[idx]) return '<li class="pb-thumbnail-editor__item" data-id=""></li>';
          return makePbThumbnailItem({ image: images[idx], idx });
        }, range(6))}
      </ul>
      <div
        class="pb-thumbnail-editor__view-area"
        is-show-upload="${images.length ? 'false' : 'true'}"
        data-length="${images.length || '0'}"
      >
        <div class="pb-thumbnail-editor__upload">
          <div class="pb-thumbnail-editor__upload-icon">
            <img
              src="//s3.marpple.co/files/u_218933/2022/8/original/c21f831e7955dfcbcb88b3c08fb56cd7b96c0c4b1.png"
              alt=""
            />
          </div>
          <p class="pb-thumbnail-editor__update-text1">업로드 된 이미지가 없습니다.</p>
          <p class="pb-thumbnail-editor__update-text2">
            상품 썸네일 이미지로 등록할 이미지를 업로드해주세요.
          </p>
          <div class="pb-thumbnail-editor__upload-btn-area">
            <label>
              <input
                type="file"
                class="pb-thumbnail-editor__input-file"
                accept="image/jpeg,image/png,image/pjpeg"
                multiple
              />
              <button type="button" class="pb-thumbnail-editor__upload-btn">
                <span>썸네일 이미지 업로드</span>
              </button>
            </label>
          </div>
        </div>
        <div class="pb-thumbnail-editor__photos">
          ${go(
            images,
            ippL,
            strMap(([idx, image]) => makePbProductImageHtml({ image, idx })),
          )}
          <div class="pb-thumbnail-editor__arrow">
            <div class="pb-thumbnail-editor__arrow-prev">
              <img
                src="//s3.marpple.co/files/u_193535/2018/10/original/f_11767_1540780825772_yl3V9ZHEgJKtbVURT.png"
                alt="prev"
              />
            </div>
            <div class="pb-thumbnail-editor__arrow-next">
              <img
                src="//s3.marpple.co/files/u_193535/2018/10/original/f_11765_1540780825772_Ec5FSJl4q4V9M8mlLHn0R.png"
                alt="next"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pb-thumbnail-editor__thumb-story-image">
      <button type="button" class="pb-thumbnail-editor__btn-thumb-story-image">
        상품 상세에 이미지 반영하기
      </button>
    </div>
    <p class="pb-thumbnail-editor__text">
      이미지 권장 사이즈 : 정사각형 740px ~ 1480px / 등록 가능 형식 : jpg, png / 용량 5MB 이하
    </p>
  `;
};
